import React from "react";
import { MapPin } from "lucide-react";
import { SERVICE_AREAS, COMPANY } from "../../lib/site-data";

export const ServiceArea = () => {
  const mapSrc =
    "https://www.openstreetmap.org/export/embed.html?bbox=-92.6%2C34.95%2C-92.25%2C35.20&layer=mapnik&marker=35.0887%2C-92.4421";
  return (
    <section
      id="service-area"
      data-testid="service-area-section"
      className="relative bg-white py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-5 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-2">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB] mb-4">
              Service Area
            </div>
            <h2
              data-testid="service-area-heading"
              className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-[#1D2B53] tracking-tight leading-tight"
            >
              Proudly serving {COMPANY.location} &amp; surrounding communities.
            </h2>
            <p className="mt-5 text-lg text-gray-600 leading-relaxed">
              Local. Reliable. Right around the corner when you need us.
            </p>

            <ul
              data-testid="service-area-list"
              className="mt-8 grid grid-cols-2 gap-2"
            >
              {SERVICE_AREAS.map((area) => (
                <li
                  key={area}
                  className="flex items-center gap-2 px-3 py-2.5 rounded-lg bg-[#F3F4F6] text-[#1D2B53] text-sm font-semibold"
                >
                  <MapPin className="h-4 w-4 text-[#2563EB] shrink-0" strokeWidth={2} />
                  {area}, AR
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="relative rounded-2xl overflow-hidden border-2 border-[#1D2B53]/10 shadow-xl shadow-[#1D2B53]/5">
              <iframe
                title="Conway, Arkansas service area map"
                data-testid="service-area-map"
                src={mapSrc}
                className="w-full h-[420px]"
                loading="lazy"
              ></iframe>
              <div className="absolute top-4 left-4 bg-white rounded-xl shadow-lg px-4 py-3 flex items-center gap-3">
                <div className="h-10 w-10 rounded-lg bg-[#2563EB] flex items-center justify-center">
                  <MapPin className="h-5 w-5 text-white" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-wider font-bold text-gray-500">
                    Headquartered In
                  </div>
                  <div className="font-display font-bold text-[#1D2B53]">
                    {COMPANY.location}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
